export const GET_DRAGGABLE_INGREDIENT: 'GET_DRAGGABLE_INGREDIENT' = 'GET_DRAGGABLE_INGREDIENT';
export const GET_DRAGGABLE_BUN: 'GET_DRAGGABLE_BUN' = 'GET_DRAGGABLE_BUN';
export const DRAGGABLE_BUN_DELETE: 'DRAGGABLE_BUN_DELETE' = 'DRAGGABLE_BUN_DELETE';
export const DRAGGABLE_INGREDIENT_DELETE: 'DRAGGABLE_INGREDIENT_DELETE' = 'DRAGGABLE_INGREDIENT_DELETE'
export const DRAGGABLE_INGREDIENT_MOVE: 'DRAGGABLE_INGREDIENT_MOVE' = 'DRAGGABLE_INGREDIENT_MOVE';
export const DRAGGABLE_INGREDIENTS_CLEAR: 'DRAGGABLE_INGREDIENTS_CLEAR' = 'DRAGGABLE_INGREDIENTS_CLEAR';
export const SET_LOADER: 'SET_LOADER' = 'SET_LOADER'

export const FORGOT_PASSWORD: 'FORGOT_PASSWORD' = 'FORGOT_PASSWORD';
export const RESET_PASSWORD: 'RESET_PASSWORD' = 'RESET_PASSWORD';
export const PROTECT_RESET_PAGE: 'PROTECT_RESET_PAGE' = 'PROTECT_RESET_PAGE';

export const GET_ITEMS_REQUEST: 'GET_ITEMS_REQUEST' = 'GET_ITEMS_REQUEST';
export const GET_ITEMS_SUCCESS: 'GET_ITEMS_SUCCESS' = 'GET_ITEMS_SUCCESS';
export const GET_ITEMS_FAILED: 'GET_ITEMS_FAILED' = 'GET_ITEMS_FAILED';
export const INCREASE_COUNTER: 'INCREASE_COUNTER' = 'INCREASE_COUNTER';
export const DECREASE_COUNTER: 'DECREASE_COUNTER' = 'DECREASE_COUNTER';
export const DECREASE_BUN: 'DECREASE_BUN' = 'DECREASE_BUN';
export const RESET_COUNTER: 'RESET_COUNTER' = 'RESET_COUNTER';

export const USER_SUCCEESS: 'USER_SUCCEESS' = 'USER_SUCCEESS';
export const AUTH_CHECKED: 'AUTH_CHECKED' = 'AUTH_CHECKED';
export const REFRESH_TOKEN: 'REFRESH_TOKEN' = 'REFRESH_TOKEN';
export const USER_UPDATE: 'USER_UPDATE' = 'USER_UPDATE';

export const ORDER_ADD: 'ORDER_ADD' = 'ORDER_ADD';
export const ORDER_CLOSE: 'ORDER_CLOSE' = 'ORDER_CLOSE';

export const REGISTRATION_SUCCEESS: 'REGISTRATION_SUCCEESS' = 'REGISTRATION_SUCCEESS';

export const FEED_INIT: "FEED_INIT" = "FEED_INIT";
export const FEED_CLOSE: "FEED_CLOSE" = "FEED_CLOSE";
export const FEED_MESSAGE: "FEED_MESSAGE" = "FEED_MESSAGE"
export const FEED_OPEN: 'FEED_OPEN' = 'FEED_OPEN';
export const FEED_CLOSED: 'FEED_CLOSED' = 'FEED_CLOSED';
export const FEED_ERROR: 'FEED_ERROR' = 'FEED_ERROR';
export const FEED_SUCCESS: 'FEED_SUCCESS' = 'FEED_SUCCESS'

export const ORDERS_INIT: "ORDERS_INIT" = "ORDERS_INIT";
export const ORDERS_CLOSE: "ORDERS_CLOSE" = "ORDERS_CLOSE";
export const ORDERS_MESSAGE: "ORDERS_MESSAGE" = "ORDERS_MESSAGE"
export const ORDERS_OPEN: 'ORDERS_OPEN' = 'ORDERS_OPEN';
export const ORDERS_CLOSED: 'ORDERS_CLOSED' = 'ORDERS_CLOSED';
export const ORDERS_ERROR: 'ORDERS_ERROR' = 'ORDERS_ERROR';
